"use client";

import HeadlineText from "@/components/common/text/headline-text";
import { Text_Mobile_App_That_Section } from "@/lib/dto/mobile-app-development-service/mobile-app-that/mobile-app-that-data";
import { useEffect, useState } from "react";

function HeadingSectionMobileAppThat() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>

      <HeadlineText
        wrapperClassName="flex justify-center lg:justify-start lg:max-w-150"
        textClassName="lg:text-left items-center lg:items-start"
      >
        {Text_Mobile_App_That_Section.heading}
      </HeadlineText>
    </>
  );
}

export default HeadingSectionMobileAppThat;
